"use client";

import { c as _c } from "react/compiler-runtime";
import { cx } from "@/utils/cx";
const sizes = {
  xs: "size-2",
  sm: "size-3",
  md: "size-3.5",
  lg: "size-4",
  xl: "size-4.5",
  "2xl": "size-5 ring-[1.67px]"
};
interface AvatarCompanyIconProps {
  size: "xs" | "sm" | "md" | "lg" | "xl" | "2xl";
  src: string;
  alt?: string;
}
export const AvatarCompanyIcon = t0 => {
  const $ = _c(6);
  const {
    size,
    src,
    alt
  } = t0;
  const t1 = sizes[size];
  let t2;
  if ($[0] !== t1) {
    t2 = cx("bg-primary-25 absolute -right-0.5 -bottom-0.5 rounded-full object-cover ring-[1.5px] ring-bg-primary", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== alt || $[3] !== src || $[4] !== t2) {
    t3 = <img src={src} alt={alt} className={t2} />;
    $[2] = alt;
    $[3] = src;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};